import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const locationsApi = createApi({
  reducerPath: 'Locations',
  tagTypes: ['Locations'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getPlacesLocationHours: builder.query({
      query: ({ id }) => ({
        url: `/v1/places/business-hours/place/${id}`,
      }),
    }),
    getPlaceLocationServices: builder.query({
      query: ({ id, page, size }) => ({
        url: `/v1/places/location-service/places/${id}?page=${page}&size=${size}`,
      }),
    }),
    getPlaceLocationAdmitted: builder.query({
      query: ({ id, page, size, sortBy = 'admitted', sortDir = 'desc' }) => ({
        url: `/v1/places/admitted-patient/place/${id}?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`,
      }),
    }),

    getPlaceLocationViews: builder.query({
      query: ({ argument: { id }, page = 0, size = 5 }) => ({
        url: `/v1/logs/audit/view/place/placePlaceLocations/${id}?page=${page}&size=${size}`,
      }),
    }),

    getTimeZoneByLocation: builder.query({
      query: ({ lat, lng, timestamp }) => ({
        url: `/v1/places/location/timezone/${lat}/${lng}/${timestamp}`,
      }),
    }),
  }),
});

export const {
  useLazyGetPlacesLocationHoursQuery,
  useLazyGetPlaceLocationServicesQuery,
  useLazyGetPlaceLocationAdmittedQuery,
  useLazyGetPlaceLocationViewsQuery,
  useLazyGetTimeZoneByLocationQuery,
} = locationsApi;
